import React, {useState} from "react";
import {Route, Redirect} from "react-router-dom";

// import internal(own) modules
import MainLayout from "./MainLayout";

const MainLayoutRoute = ({render, ...rest}) => {

  // const [user,setUser] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(true);
  return (
    <Route
      {...rest}
      className={'app-logo-text'}
      render={matchProps => {
        return (
          user ? <MainLayout>{render(matchProps)}</MainLayout> : <Redirect to={'/'}/>
        )

      }}
    />
  );
};

export default MainLayoutRoute;
